import { render } from "./MfAddNotify.vue?vue&type=template&id=7be6f7e4&scoped=true"
import script from "./MfAddNotify.vue?vue&type=script&lang=js"
export * from "./MfAddNotify.vue?vue&type=script&lang=js"

import "./MfAddNotify.vue?vue&type=style&index=0&id=7be6f7e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be6f7e4"]])

export default __exports__